<template>
  <nav class="container-fluid Navbar">
    <div class="container">
      <div class="row">
        <!-- desktop navbar -->
        <div class="col-md-12 d-none d-md-flex Navbar-wrapper mx-auto mt-5">
          <ul class="Navbar-list">
            <li class="Navbar-list-item" @click="jumpToSection('#app')">
                <app-logo-touchstands/>
                <h1 class="Navbar-title">
                  Touch<br>
                  <span style="color: #7e7e7e">Stands</span>
                </h1>
            </li>
            <li
              class="Navbar-list-item linkInline linkInline--black"
              @click="jumpToSection('#about')">
              About
            </li>
            <li
              class="Navbar-list-item linkInline linkInline--black"
              @click="jumpToSection('#spec')">
              Specifications
            </li>
            <li
              class="Navbar-list-item linkInline linkInline--black"
              >
              <a href="questions">Common Questions</a>
            </li>
            <li
              class="Navbar-list-item linkInline linkInline--black"
              @click="jumpToSection('#contact')">
              Contact
            </li>
          </ul>
          <a href="http://ideum.com/" target="_blank" rel="noopener">
            <div class="Navbar-logo">
              <p class="Navbar-logo-title">Made by </p>
              <app-logo-ideum
                :width="'50%'"
                :height="'25%'"
              />
            </div>
          </a>
        </div>

        <!-- mobile navbar -->
        <div class="col-12 d-md-none d-flex justify-content-end">
          <div
            class="Hamburger mt-4"
            title="Open navigation menu"
            :class="{ 'is-open': menuIsOpen }"
            @click="functionHandler(toggleMenu, toggleScroll)"
          ></div>
        </div>

      </div>
      <!-- mobile modal       -->
      <transition name="fade">
      <div class="Modal" v-if="menuIsOpen">
        <ul class="Modal-navList">
          <li class="Modal-navList-item mb-3" @click="mobileNavigation('#app')">
            <app-logo-touchstands/>
              <h1 class="Navbar-title">
                Touch<br>
                <span style="color: #7e7e7e">Stands</span>
              </h1>
          </li>
          <li class="Modal-navList-item" @click="mobileNavigation('#about')">About</li>
          <li class="Modal-navList-item" @click="mobileNavigation('#spec')">Specifications</li>
          <li class="Modal-navList-item"><a href="https://touchstands.com/questions">Common Questions</a></li>
          <li class="Modal-navList-item" @click="mobileNavigation('#contact')">Contact</li>
          <li class="Modal-navList-item mt-5">
            <app-logo-ideum
              :color="'teal'"
              :width="'25%'"
              :height="'100%'"
            />
          </li>
        </ul>
      </div>
      </transition>
    </div>
  </nav>
</template>


<script>
import appLogoIdeum from './../components/Logo-ideum'
import appLogoTouchstands from './../components/Logo-touchstands'

import jump from 'jump.js'

export default {
  components: {
    appLogoIdeum,
    appLogoTouchstands
  },

  data () {
    return {
      menuIsOpen: false
    }
  },

  methods: {
    functionHandler (fn1, fn2) {
      fn1()
      fn2()
    },

    jumpToSection (selector) {
      jump(selector, {
        offset: -80
      })
    },

    mobileNavigation (section) {
      this.toggleMenu()
      this.toggleScroll()
      this.jumpToSection(section)
    },

    toggleScroll () {
      const body = document.getElementsByTagName('body')
      if (this.menuIsOpen) {
        body[0].setAttribute('style', 'overflow: hidden;')
      } else {
        body[0].removeAttribute('style', 'overflow: hidden;')
      }
    },

    toggleMenu () {
      this.menuIsOpen = !this.menuIsOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/styles/_variables.scss';

.Hamburger {
  background-color: $colorWhite;
  border-radius: 50%;
  box-shadow: 0 3px 30px rgba(0, 0, 0, .1);
  position: relative;
  transition: $transitionPrimary;
  width: 50px;
  height: 50px;
  z-index: 1;
  // hamburger open
  &.is-open {
    background: $gradientBlue;
    &::after {
      background: $colorWhite;
      content: '';
      margin: auto;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: rotate(-45deg);
      width: 60%;
      height: 4px;
    }
    &::before {
      background: $colorWhite;
      content: '';
      margin: auto;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: rotate(45deg);
      width: 60%;
      height: 4px;
    }
  }
  // hamburger closed
  &::after {
    background: $gradientBlue;
    content: '';
    margin: 1em auto 1em auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: $transitionPrimary;
    width: 60%;
    height: 4px;
  }
  &::before {
    background: $gradientBlue;
    content: '';
    margin: auto auto 1em auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: $transitionPrimary;
    width: 60%;
    height: 4px;
  }
}

.Modal {
  background-color: $colorWhite;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.Modal-navList {
  align-items: center;
  color: $colorTeal;
  display: flex;
  flex-direction: column;
  font-size: 4vmax;
  justify-content: center;
  letter-spacing: 1px;
  list-style-type: none;
  // margin: -5vh 0 0 0;
  // padding: 0 0 0 15vw;
  text-transform: uppercase;
  width: auto;
  height: 100%;
}

.Modal-navList-item {
  display: flex;
  justify-content: center;
  padding: 0 0 1em 0;
}

.Navbar-logo {
  align-items: center;
  background: $gradientBlue;
  color: $colorWhite;
  display: flex;
  font-size: .75em;
  font-weight: 400;
  justify-content: center;
  padding: 0 0 4px 0;
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  height: $navbarHeight;
}

.Navbar-logo-title {
  margin: 0 -14px -8px 0;
}

.Navbar-title {
  display: inline-block;
  font-size: 1rem;
  margin: auto 0 auto 1em;
  line-height: 1.25em;
  text-transform: uppercase;
}

.Navbar-title-wrapper {
  background: $colorWhite;
}

.Navbar {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  position: fixed;
  z-index: 9;
}

/* hacks for adding 'Common Questions into Navbar */
.Modal-navList-item {
  cursor: pointer;
}
.Modal-navList-item a {
  color: #56c3d9;
}
.Navbar-list-item a {
  color: #000000;
}
.Navbar-list-item a:hover {
  color: #56c3d9;
}

.Navbar-list {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 69%;
  height: $navbarHeight;
  /* hacks for adding 'Common Questions into Navbar */
  @media screen and (min-width: $grid-lg) {
    /*width: 50%;*/
    width: 61%;
  }
  @media screen and (max-width: 1200px) {
    width: 70%;
  }
}

.Navbar-list-item {
  cursor: pointer;
  display: inline-flex;
}

.Navbar-wrapper {
  background-color: $colorWhite;
  box-shadow: 0 0 80px 5px rgba(0, 0, 0, .1);
}

/* hack for adding 'Common Questions link into Navbar */
@media (min-width: 768px) and (max-width: 991px) {
  .Navbar-list { width: 71%; }
  .Navbar-list-item { font-size: 12px; }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue